__turbopack_context__.v({
  "attributes": "VisualSearchIllustration-module__A2RoIq__attributes",
  "composition": "VisualSearchIllustration-module__A2RoIq__composition",
  "corner": "VisualSearchIllustration-module__A2RoIq__corner",
  "cornerBottomLeft": "VisualSearchIllustration-module__A2RoIq__cornerBottomLeft" + " " + "VisualSearchIllustration-module__A2RoIq__corner",
  "cornerBottomRight": "VisualSearchIllustration-module__A2RoIq__cornerBottomRight" + " " + "VisualSearchIllustration-module__A2RoIq__corner",
  "cornerTopLeft": "VisualSearchIllustration-module__A2RoIq__cornerTopLeft" + " " + "VisualSearchIllustration-module__A2RoIq__corner",
  "cornerTopRight": "VisualSearchIllustration-module__A2RoIq__cornerTopRight" + " " + "VisualSearchIllustration-module__A2RoIq__corner",
  "likes": "VisualSearchIllustration-module__A2RoIq__likes",
  "likesCount": "VisualSearchIllustration-module__A2RoIq__likesCount",
  "likesIcon": "VisualSearchIllustration-module__A2RoIq__likesIcon",
  "listingImage": "VisualSearchIllustration-module__A2RoIq__listingImage",
  "lit": "VisualSearchIllustration-module__A2RoIq__lit",
  "matchCard": "VisualSearchIllustration-module__A2RoIq__matchCard",
  "phone": "VisualSearchIllustration-module__A2RoIq__phone",
  "photo": "VisualSearchIllustration-module__A2RoIq__photo",
  "price": "VisualSearchIllustration-module__A2RoIq__price",
  "priceNow": "VisualSearchIllustration-module__A2RoIq__priceNow",
  "priceWas": "VisualSearchIllustration-module__A2RoIq__priceWas",
  "scan": "VisualSearchIllustration-module__A2RoIq__scan",
  "size": "VisualSearchIllustration-module__A2RoIq__size",
  "stage": "VisualSearchIllustration-module__A2RoIq__stage",
});
